meedy.factory('meedy.videoConsultationModel', ['$rootScope', 'applicationModel', 'meedy.baseModel', 'meedy.videoConsultationService',
    function ($rootScope, applicationModel, baseModel, videoConsultationService) {

        function VideoConsultationModel() {

            this.details = undefined;
            this.chatting = false;

            this.beginVideoConsultation = function (wrapper) {
                videoConsultationService.beginVideoConsultation(wrapper).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.BEGIN.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.BEGIN.ERROR, error);
                    }
                )
            };

            this.endVideoConsultation = function (wrapper) {
                videoConsultationService.endVideoConsultation(wrapper).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.END.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.END.ERROR, error);
                    }
                )
            };

            this.sendACKStatus = function (wrapper) {
                videoConsultationService.sendACKStatus(wrapper).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.SEND_ACK_STATUS.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.SEND_ACK_STATUS.ERROR, error);
                    }
                )
            };

            this.sendACKFreeStatus = function (wrapper) {
                videoConsultationService.sendACKFreeStatus(wrapper).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.SEND_ACK_FREE_STATUS.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.SEND_ACK_FREE_STATUS.ERROR, error);
                    }
                )
            };

            this.streamingDetails = function (idTerm) {
                videoConsultationService.streamingDetails(idTerm).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.STREAMING_DETAILS.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.STREAMING_DETAILS.ERROR, error);
                    }
                )
            };

            this.sendAudioBlob = function (idOrder, timestamp, blob) {
                videoConsultationService.sendAudioBlob(idOrder, timestamp, blob).then(
                    function (resources) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.SEND_AUDIO_BLOB.SUCCESS, resources);
                    },
                    function (error) {
                        $rootScope.$broadcast(Event.MEEDY.VIDEO_CONSULTATION.SEND_AUDIO_BLOB.ERROR, error);
                    }
                )
            };


        }

        return new VideoConsultationModel();
    }
]);
